import { Injectable, OnDestroy } from '@angular/core';
import { of, Subscription } from 'rxjs';
import { delay, map, tap } from 'rxjs/operators';
import { tblToken } from '../../_models/app-models';
import { AppFormsNavigatorService } from '../../_services/app-forms-navigator-service';
@Injectable({
  providedIn: 'root'
})
export class AuthJWTService implements OnDestroy  {
  private timer: Subscription | null = null;
  refreshToken = "refresh_Token"
  accessToken = "access_Token"

  constructor(private appFormsNavigatorService: AppFormsNavigatorService) {
    this.startTokenTimer();
    window.addEventListener('storage', this.storageEventListener.bind(this));
  }

  clerJWTToken() {
    localStorage.removeItem(this.refreshToken);
    localStorage.removeItem(this.accessToken);
  }

  setJWTRefreshToken(tblToken: tblToken) {
    this.setLocalStorage(tblToken.accessToken, tblToken.refreshToken);
    this.startTokenTimer();
  }

  setLocalStorage(accessToken, refreshToken) {
    localStorage.setItem(this.accessToken, accessToken);
    localStorage.setItem(this.refreshToken, refreshToken);
  }

  getRefreshToken() {
    return localStorage.getItem(this.refreshToken);
  }

   startTokenTimer() {
    const timeout = this.getTokenRemainingTime();
    this.timer = of(true)
      .pipe(
        delay(timeout),
        tap({
          next: () => this.refreshJWTToken().subscribe(),
        })
      )
      .subscribe();
  }

  private getTokenRemainingTime() {

    const accessToken = localStorage.getItem(this.accessToken);
    if (!accessToken || accessToken == 'undefined') {
      return 0;
    }

    const jwtToken = JSON.parse(atob(accessToken.split('.')[1]));
    const expires = new Date(jwtToken.exp * 1000);
    return expires.getTime() - Date.now();
  }

  refreshJWTToken() {
    const refreshToken = localStorage.getItem(this.refreshToken);
    const accessToken = localStorage.getItem(this.accessToken);
    if (!refreshToken) {
      this.clerJWTToken();
      return of(null);
    }

    return this.appFormsNavigatorService.refreshToken(accessToken, refreshToken)
      .pipe(map(r => {
        var result = r.data;
        this.setLocalStorage(result.accessToken, result.refreshToken.tokenString);
        this.startTokenTimer();
        return result;
      }))
  }

  private storageEventListener(event: StorageEvent) {
    this.stopTokenTimer();
  }

  private stopTokenTimer() {
    this.timer?.unsubscribe();
  }

  ngOnDestroy(): void {
    window.removeEventListener('storage', this.storageEventListener.bind(this));
  }

}
